import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-32a0d540"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "header-conversion-window"
};
import { exceptionallyIncludeConversionWindowRoutes } from '@/helpers/menu';
import { useStore } from 'vuex';
import { computed } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'HeaderConversionWindow',
    props: {
        route: {}
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const conversionWindow = computed(() => store.getters['getLookback']);
        const showConversionWindow = computed(() => exceptionallyIncludeConversionWindowRoutes.some(el => props.route === el));
        return (_ctx, _cache) => {
            return (showConversionWindow.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("p", null, [
                        _createTextVNode(_toDisplayString(_ctx.$t('360.conversion-window')) + " ", 1),
                        _createElementVNode("span", null, _toDisplayString(conversionWindow.value) + " " + _toDisplayString(_ctx.$tc('day', conversionWindow.value)), 1)
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
